import { cn } from "../../../../utils";
import type { IconProps } from "../../types";
import { iconSizes } from "../../types";

export function View3D({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9259 9.92902L17.9904 6.53519C18.2104 9.16226 18.2052 11.3612 17.944 14.0345C17.9286 14.1918 17.8422 14.3348 17.7081 14.4223C15.3812 15.9398 13.3784 16.9809 10.9259 17.8586V9.92902ZM9.07406 9.92917L2.00945 6.53236C1.78939 9.1605 1.79501 11.3602 2.05646 14.0345C2.07183 14.1918 2.15819 14.3348 2.29238 14.4224C4.61961 15.9403 6.62136 16.9813 9.07406 17.8592V9.92917ZM10.7464 0.120778C10.2616 -0.040259 9.73663 -0.0402605 9.25186 0.120781C6.27072 1.11109 3.96029 2.27888 1.28532 4.02309C0.676496 4.42007 0.283275 5.07309 0.215766 5.79501C-0.0640236 8.78701 -0.0788991 11.2248 0.213392 14.2147C0.283591 14.9327 0.676779 15.5795 1.28072 15.9735C3.9577 17.7194 6.26894 18.8883 9.25195 19.8792C9.73673 20.0403 10.2617 20.0403 10.7465 19.8792C13.7295 18.8883 16.0424 17.7195 18.7197 15.9735C19.3237 15.5795 19.7169 14.9327 19.7869 14.2146C20.0792 11.2247 20.0637 8.78702 19.7838 5.7952C19.7163 5.07331 19.3231 4.42029 18.7142 4.02331C16.0389 2.27905 13.7276 1.11109 10.7464 0.120778Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Building({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.73171 1.3125H13V14H7.87805V11.2292H6.12195V14H1V1.3125H6.26829V0H7.73171V1.3125ZM2.46341 2.77083V12.5417H4.65854V9.77083H9.34146V12.5417H11.5366V2.77083H2.46341ZM5.09756 3.9375H3.34146V5.6875H5.09756V3.9375ZM5.09756 6.70833H3.34146V8.45833H5.09756V6.70833ZM7.87805 6.70833H6.12195V8.45833H7.87805V6.70833ZM8.90244 6.70833H10.6585V8.45833H8.90244V6.70833ZM6.12195 3.9375H7.87805V5.6875H6.12195V3.9375ZM10.6585 3.9375H8.90244V5.6875H10.6585V3.9375Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Event({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.47899 5.13329C3.47899 3.15735 5.05536 1.55554 6.99995 1.55554C8.94449 1.55554 10.5209 3.15735 10.5209 5.13329V8.45051L10.6213 8.62959L11.3652 9.95547H2.63477L3.37855 8.62953L3.47899 8.45045V5.13329ZM6.99995 0C4.20991 0 1.94815 2.29825 1.94815 5.13329V8.0383L0.652464 10.3481L0.000122069 11.511H14L13.3476 10.348L12.0517 8.03823V5.13329C12.0517 2.29825 9.78994 0 6.99995 0ZM5.77512 13.9999H8.22444V12.4443H5.77512V13.9999Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IoT({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.81232 1.28548C9.62806 1.5714 9.71529 1.94952 10.0072 2.13001C11.6567 3.15013 12.75 4.94951 12.75 6.99846C12.75 9.04926 11.6547 10.85 10.0027 11.8697C9.71064 12.0499 9.62305 12.4279 9.80705 12.7141C9.99106 13.0001 10.377 13.0859 10.669 12.9057C12.669 11.6713 14 9.48739 14 6.99846C14 4.51179 12.6714 2.32953 10.6745 1.09461C10.3826 0.914111 9.99659 0.999566 9.81232 1.28548ZM7 5.77552C7.69036 5.77552 8.25 6.32373 8.25 7C8.25 7.67626 7.69036 8.22447 7 8.22447C6.30964 8.22447 5.75 7.67626 5.75 7C5.75 6.32373 6.30964 5.77552 7 5.77552ZM8.17051 4.39752C7.86038 4.24907 7.73184 3.88244 7.88339 3.57864C8.03495 3.27486 8.40921 3.14893 8.71934 3.29739C10.116 3.96596 11.0801 5.37213 11.0801 7.00005C11.0801 8.62645 10.1178 10.0315 8.72329 10.7009C8.41332 10.8496 8.03891 10.7241 7.88704 10.4204C7.73516 10.1168 7.86331 9.75003 8.17328 9.60125C9.15577 9.12969 9.83008 8.14143 9.83008 7.00005C9.83008 5.8576 9.1545 4.86856 8.17051 4.39752ZM4.18768 1.28548C4.37194 1.5714 4.28471 1.94952 3.99283 2.13001C2.34329 3.15013 1.25 4.94951 1.25 6.99846C1.25 9.04926 2.34528 10.85 3.99732 11.8697C4.28936 12.0499 4.37695 12.4279 4.19295 12.7141C4.00894 13.0001 3.62303 13.0859 3.33098 12.9057C1.33105 11.6713 0 9.48739 0 6.99846C0 4.51179 1.32864 2.32953 3.32554 1.09461C3.61742 0.914111 4.00341 0.999566 4.18768 1.28548ZM5.82949 4.39752C6.13962 4.24907 6.26816 3.88244 6.11661 3.57864C5.96505 3.27486 5.59079 3.14893 5.28066 3.29739C3.88405 3.96596 2.91992 5.37213 2.91992 7.00005C2.91992 8.62645 3.88224 10.0315 5.27671 10.7009C5.58668 10.8496 5.96109 10.7241 6.11296 10.4204C6.26484 10.1168 6.13669 9.75003 5.82672 9.60125C4.84423 9.12969 4.16992 8.14143 4.16992 7.00005C4.16992 5.8576 4.8455 4.86856 5.82949 4.39752Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Park({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        d="M5.97621 11.3188H1.5577C1.34216 11.3188 1.18051 11.2228 1.07274 11.0308C0.964975 10.8389 0.976951 10.653 1.10867 10.473L3.92862 6.38817H3.26405C3.04395 6.38817 2.88114 6.29219 2.77568 6.10026C2.67017 5.90832 2.68328 5.72236 2.81501 5.54241L6.55098 0.233933C6.60544 0.160514 6.67347 0.103172 6.75502 0.0619024C6.83667 0.020633 6.91832 0 7.00001 0C7.08166 0 7.16332 0.020633 7.245 0.0619024C7.32655 0.103172 7.39455 0.160514 7.44905 0.233933L11.185 5.54241C11.3167 5.72236 11.3298 5.90832 11.2243 6.10026C11.1188 6.29219 10.956 6.38817 10.736 6.38817H10.0894L12.8913 10.473C13.023 10.653 13.035 10.8389 12.9273 11.0308C12.8195 11.2228 12.6578 11.3188 12.4423 11.3188H8.04177V13.4602C8.04177 13.6131 7.99087 13.7413 7.8891 13.8447C7.78729 13.9482 7.66146 14 7.51155 14H6.50643C6.35649 14 6.23065 13.9482 6.12888 13.8447C6.02708 13.7413 5.97621 13.6131 5.97621 13.4602V11.3188Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CCTV({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        d="M3.77338 2.06961C3.28425 1.93485 2.76349 1.99723 2.31764 2.24398C1.87179 2.49073 1.53456 2.90321 1.37493 3.39702L1.34184 3.51195L0.656853 6.13958C0.570457 6.47085 0.609055 6.82344 0.764915 7.12671C0.920777 7.42998 1.18239 7.66156 1.49737 7.77505L1.59267 7.80497L3.14796 8.23339V9.28064C3.14792 9.4473 3.08831 9.60815 2.98046 9.73263C2.87261 9.85712 2.72402 9.93657 2.56291 9.9559L2.48547 9.96067H1.82365C1.82346 9.78734 1.75887 9.62063 1.64307 9.49459C1.52727 9.36856 1.36901 9.29272 1.20061 9.28256C1.03222 9.2724 0.8664 9.3287 0.737044 9.43994C0.607689 9.55119 0.524557 9.70899 0.504633 9.8811L0.5 9.96067V11.3207C0.500187 11.494 0.564779 11.6608 0.680578 11.7868C0.796376 11.9128 0.954642 11.9887 1.12304 11.9988C1.29143 12.009 1.45725 11.9527 1.5866 11.8414C1.71596 11.7302 1.79909 11.5724 1.81902 11.4003L1.82365 11.3207H2.48547C2.99191 11.3208 3.47921 11.1219 3.84768 10.7649C4.21615 10.408 4.43793 9.91979 4.46764 9.40032L4.47095 9.28064V8.59789L8.78141 9.78386C9.04116 9.85538 9.31595 9.8439 9.5692 9.75097C9.82245 9.65804 10.0421 9.48805 10.199 9.26364L10.2593 9.16911L12.2547 5.75128C12.3299 5.62249 12.3764 5.47822 12.3911 5.32879C12.4057 5.17935 12.3881 5.02843 12.3394 4.88682C12.2907 4.7452 12.2122 4.61637 12.1095 4.50954C12.0067 4.40271 11.8823 4.32052 11.7451 4.26882L11.6603 4.24162L3.77338 2.06961ZM12.2791 6.33339L11.2037 8.20347C11.1188 8.35843 11.0963 8.54141 11.1412 8.71317C11.186 8.88494 11.2945 9.03183 11.4435 9.12237C11.5924 9.21291 11.77 9.23988 11.9381 9.19752C12.1061 9.15516 12.2514 9.04682 12.3427 8.89574L13.4181 7.02566C13.501 6.87082 13.5219 6.68893 13.4765 6.51851C13.4311 6.34809 13.3229 6.20252 13.1749 6.11263C13.0268 6.02273 12.8505 5.99558 12.6834 6.03691C12.5162 6.07825 12.3712 6.18414 12.2791 6.33339Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Layer({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        d="M0.347721 4.88293L6.64988 8.43414C6.78993 8.50244 6.85996 8.50244 7 8.50244C7.14005 8.50244 7.21007 8.50244 7.35012 8.43414L13.6523 4.88293C13.7923 4.81463 13.8624 4.74634 13.9324 4.60976C14.0724 4.26829 14.0024 3.85854 13.6523 3.65366L7.35012 0.102439C7.14005 -0.0341463 6.85996 -0.0341463 6.64988 0.102439L0.347721 3.65366C0.207673 3.72195 0.137649 3.79024 0.0676253 3.92683C-0.0724226 4.26829 -0.00239867 4.67805 0.347721 4.88293ZM13.6523 6.38537L13.5122 6.31707L7.35012 9.8C7.14005 9.93659 6.85996 9.93659 6.64988 9.8L0.487769 6.31707L0.347721 6.38537C-0.00239867 6.59024 -0.0724226 7 0.0676253 7.34146C0.137649 7.47805 0.207673 7.54634 0.347721 7.61463L6.64988 11.1659C6.85996 11.3024 7.14005 11.3024 7.35012 11.1659L13.6523 7.61463C14.0024 7.40976 14.0724 7 13.9324 6.65854C13.8624 6.52195 13.7923 6.45366 13.6523 6.38537ZM13.6523 9.11707L13.5122 9.04878L7.35012 12.5317C7.14005 12.6683 6.85996 12.6683 6.64988 12.5317L0.487769 9.04878L0.347721 9.11707C-0.00239867 9.32195 -0.0724226 9.73171 0.0676253 10.0732C0.137649 10.2098 0.207673 10.278 0.347721 10.3463L6.64988 13.8976C6.85996 14.0341 7.14005 14.0341 7.35012 13.8976L13.6523 10.3463C14.0024 10.1415 14.0724 9.73171 13.9324 9.39024C13.8624 9.25366 13.7923 9.18537 13.6523 9.11707Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Chart({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        d="M3.18182 7.63636H0.636364C0.254545 7.63636 0 7.89091 0 8.27273V13.3636C0 13.7455 0.254545 14 0.636364 14H3.18182C3.56364 14 3.81818 13.7455 3.81818 13.3636V8.27273C3.81818 7.89091 3.56364 7.63636 3.18182 7.63636ZM13.3636 5.09091H10.8182C10.4364 5.09091 10.1818 5.34545 10.1818 5.72727V13.3636C10.1818 13.7455 10.4364 14 10.8182 14H13.3636C13.7455 14 14 13.7455 14 13.3636V5.72727C14 5.34545 13.7455 5.09091 13.3636 5.09091ZM8.27273 0H5.72727C5.34545 0 5.09091 0.254545 5.09091 0.636364V13.3636C5.09091 13.7455 5.34545 14 5.72727 14H8.27273C8.65455 14 8.90909 13.7455 8.90909 13.3636V0.636364C8.90909 0.254545 8.65455 0 8.27273 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Dashboard({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.42857 0C0.639593 0 0 0.639593 0 1.42857V10C0 10.789 0.639593 11.4286 1.42857 11.4286H7.14286C7.93184 11.4286 8.57143 10.789 8.57143 10V1.42857C8.57143 0.639593 7.93184 0 7.14286 0H1.42857ZM11.4286 1.42857C11.4286 0.639593 12.0682 0 12.8571 0H18.5714C19.3604 0 20 0.639593 20 1.42857V4.3C20 5.08897 19.3604 5.72857 18.5714 5.72857H12.8571C12.0682 5.72857 11.4286 5.08897 11.4286 4.3V1.42857ZM11.4286 10C11.4286 9.21103 12.0682 8.57143 12.8571 8.57143H18.5714C19.3604 8.57143 20 9.21103 20 10V18.5714C20 19.3604 19.3604 20 18.5714 20H12.8571C12.0682 20 11.4286 19.3604 11.4286 18.5714V10ZM0 15.7C0 14.911 0.639593 14.2714 1.42857 14.2714H7.14286C7.93184 14.2714 8.57143 14.911 8.57143 15.7V18.5714C8.57143 19.3604 7.93184 20 7.14286 20H1.42857C0.639593 20 0 19.3604 0 18.5714V15.7Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Graph({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        d="M4.54545 10.9091H0.909091C0.363636 10.9091 0 11.2727 0 11.8182V19.0909C0 19.6364 0.363636 20 0.909091 20H4.54545C5.09091 20 5.45455 19.6364 5.45455 19.0909V11.8182C5.45455 11.2727 5.09091 10.9091 4.54545 10.9091ZM19.0909 7.27273H15.4545C14.9091 7.27273 14.5455 7.63636 14.5455 8.18182V19.0909C14.5455 19.6364 14.9091 20 15.4545 20H19.0909C19.6364 20 20 19.6364 20 19.0909V8.18182C20 7.63636 19.6364 7.27273 19.0909 7.27273ZM11.8182 0H8.18182C7.63636 0 7.27273 0.363636 7.27273 0.909091V19.0909C7.27273 19.6364 7.63636 20 8.18182 20H11.8182C12.3636 20 12.7273 19.6364 12.7273 19.0909V0.909091C12.7273 0.363636 12.3636 0 11.8182 0Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Map({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path d="M5.41667 3.125L0 0V16.875L5.41667 20V3.125Z" fill="currentColor" />
      <path d="M7.2915 3.125L12.7081 0V16.875L7.2915 20V3.125Z" fill="currentColor" />
      <path d="M19.9996 3.125L14.583 0V16.875L19.9996 20V3.125Z" fill="currentColor" />
    </svg>
  );
}

export function Logout({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <path
        d="M16.1579 16H14.2632V18H2.89474V2H14.2632V4H16.1579V1C16.1579 0.44772 15.7337 0 15.2105 0H1.94737C1.42414 0 1 0.44772 1 1V19C1 19.5523 1.42414 20 1.94737 20H15.2105C15.7337 20 16.1579 19.5523 16.1579 19V16ZM14.2632 9H7.63158V11H14.2632V14L19 10L14.2632 6V9Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function Folding({ size = "md", className, ref, ...props }: IconProps) {
  const sizeValue = typeof size === "number" ? `${size}px` : iconSizes[size];
  return (
    <svg
      ref={ref}
      style={{ width: sizeValue, height: sizeValue }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      {...props}
    >
      <rect x="8" y="2" width="4" height="4" rx="1" fill="currentColor" />
      <rect x="8" y="8" width="4" height="4" rx="1" fill="currentColor" />
      <rect x="8" y="14" width="4" height="4" rx="1" fill="currentColor" />
    </svg>
  );
}
